import clsx from 'clsx';
import React from 'react';
import { RadioGroup, RadioGroupProps } from 'react-aria-components';

import { FormFieldSupportingText } from './FormFieldSupportingText';
import { RadioField, RadioFieldProps } from './RadioField';
import { FormFieldErrorProps, FormFieldStyleProps } from './types';

type RadioGroupFieldProps = RadioGroupProps &
  FormFieldErrorProps &
  FormFieldStyleProps & {
    options: RadioFieldProps[];
  };

export const RadioGroupField = ({
  errorMessage,
  errorLeadingIconName,
  className,
  options,
  ...props
}: RadioGroupFieldProps) => {
  const id = React.useId();
  const errorId = `error-${id}`;

  return (
    <div className={clsx('relative w-full', className)}>
      <RadioGroup aria-describedby={`${errorId}`} className="flex flex-col gap-12" {...props}>
        {options.map(option => (
          <RadioField {...option} key={option.value} isError={!!errorMessage} />
        ))}
      </RadioGroup>

      {errorMessage && (
        <FormFieldSupportingText id={errorId} leadingIconName={errorLeadingIconName} isError>
          {errorMessage}
        </FormFieldSupportingText>
      )}
    </div>
  );
};
